import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Button, Input, Card } from '../../components/ui';
import styles from './Auth.module.css';

export function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Check if redirecting to admin after login
  const redirectTo = searchParams.get('redirect') || '/discover';
  const isAdminLogin = redirectTo === '/admin';

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const { error } = await signIn(email, password);

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      navigate(redirectTo);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img src="/logo.png" alt="Mas Match" className={styles.logoImage} />
        <p className={styles.tagline}>
          {isAdminLogin ? 'Band Manager Login' : 'Find your perfect band'}
        </p>
      </div>

      <Card className={styles.card}>
        <form onSubmit={handleSubmit} className={styles.form}>
          <h2 className={styles.title}>
            {isAdminLogin ? 'Sign in to manage your band' : 'Welcome back'}
          </h2>

          {error && <div className={styles.error}>{error}</div>}

          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />

          <Input
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Your password"
            required
          />

          <Button type="submit" fullWidth loading={loading}>
            {isAdminLogin ? 'Sign In as Manager' : 'Sign In'}
          </Button>

          <p className={styles.footer}>
            Don't have an account? <Link to="/signup">Sign up</Link>
          </p>

          {!isAdminLogin && (
            <p className={styles.bandManager}>
              <Link to="/login?redirect=/admin">Band Manager? Login here</Link>
            </p>
          )}

          {isAdminLogin && (
            <p className={styles.bandManager}>
              <Link to="/login">Back to masquerader login</Link>
            </p>
          )}
        </form>
      </Card>
    </div>
  );
}
